<mat-card-header>
  <div class="header-content">
    <div class="title-section">
      <mat-card-title>
        <mat-icon class="title-icon" [color]="getIconColor()">
          {{ getIconName() }}
        </mat-icon>
        @if (isSinglePage) {
          <span>
            Page {{ firstPageNumber || 1 }} {{ getTaskTypeDisplayName() }}
            @if (isCompleted) {
              <span class="status-completed">Completed</span>
            }
            @if (isFailed) {
              <span class="status-failed">Failed</span>
            }
            @if (isCancelled) {
              <span class="status-cancelled">Cancelled</span>
            }
            @if (isRunning) {
              <span class="status-progress">In Progress</span>
            }
          </span>
        }
        @if (isMultiPageTaskWithNumbers()) {
          <span>
            {{ getPageNumbersLength() }} Pages {{ getTaskTypeDisplayName() }}
            @if (isCompleted) {
              <span class="status-completed">Completed</span>
            }
            @if (isFailed) {
              <span class="status-failed">Failed</span>
            }
            @if (isCancelled) {
              <span class="status-cancelled">Cancelled</span>
            }
            @if (isRunning) {
              <span class="status-progress">In Progress</span>
            }
          </span>
        }
        @if (!isSinglePage && !isMultiPageTaskWithNumbers()) {
          <span>
            Page {{ getTaskTypeDisplayName() }}
            @if (isCompleted) {
              <span class="status-completed">Completed</span>
            }
            @if (isFailed) {
              <span class="status-failed">Failed</span>
            }
            @if (isCancelled) {
              <span class="status-cancelled">Cancelled</span>
            }
            @if (isRunning) {
              <span class="status-progress">In Progress</span>
            }
          </span>
        }
      </mat-card-title>
      @if (taskConfig) {
        <mat-card-subtitle>
          <span class="file-info">
            File:
            <mat-icon class="file-icon">{{ getFileIcon() }}</mat-icon>
            {{ getDisplayFilename() }}
          </span>
          @if (isMultiPageTaskWithNumbers()) {
            <span>(Pages: {{ getPageNumbersString() }})</span>
          }
          @if (taskId) {
            <br />
          }
          @if (taskId) {
            <span class="task-id-subtitle">
              Task ID:
              <code>{{ taskId }}</code>
            </span>
          }
        </mat-card-subtitle>
      }
    </div>
    @if (overallProgress === 100 && !isRunning) {
      <div class="header-actions">
        <!-- Cost Analysis Summary (clickable for details) -->
        @if (hasCostAnalysis()) {
          <div
            class="cost-summary-header"
            (click)="onOpenCostDetails()"
            (keydown.enter)="onOpenCostDetails()"
            (keydown.space)="onOpenCostDetails(); $event.preventDefault()"
            matTooltip="Click for cost details"
            tabindex="0"
            role="button"
          >
            <div class="cost-amount">{{ formatCost(costAnalysis?.totalCostUsd || 0) }}</div>
            <div class="cost-tokens">{{ formatTokens(costAnalysis?.totalTokens || 0) }} tokens</div>
          </div>
        }
        <!-- Issue #612: Show special message when cost has a known reason for being zero -->
        @if (!hasCostAnalysis() && hasSpecialCostDataSource()) {
          <div class="cost-summary-header cached-report" [matTooltip]="getCostDataSourceMessage()?.tooltip || ''">
            <div class="cost-amount">$0.00</div>
            <div class="cost-tokens">{{ getCostDataSourceMessage()?.message }}</div>
          </div>
        }
        <!-- Show placeholder when cost analysis should be available but isn't -->
        @if (!hasCostAnalysis() && !hasSpecialCostDataSource() && shouldShowCostPlaceholder()) {
          <div class="cost-placeholder-header" matTooltip="Cost analysis not available">
            <div class="cost-placeholder-text">
              <mat-icon class="cost-placeholder-icon">help_outline</mat-icon>
              Cost data unavailable
            </div>
          </div>
        }
        <button mat-icon-button (click)="onDismissCard()" matTooltip="Dismiss" class="dismiss-button">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }
  </div>
</mat-card-header>
